import { musicsConstants } from "../actions/constants/musicsConstant";

type MusicsDataState = {
	items: any[];
};

const initialMusicsData: MusicsDataState = {
	items: [],
};

const musicsData = (state = initialMusicsData, action: any) => {
	switch (action.type) {
		case musicsConstants.MusicsGetByfilterRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case musicsConstants.MusicsGetByfilterSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case musicsConstants.MusicsGetByfilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		case musicsConstants.MusicsDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case musicsConstants.MusicsDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailComplete: true,
				musicsInput: action.payload,
			};
		case musicsConstants.MusicsDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case musicsConstants.MusicsDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
			};
		case musicsConstants.MusicsDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case musicsConstants.MusicsDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload,
			};

		case musicsConstants.MusicsSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
			};
		case musicsConstants.MusicsSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
			};
		case musicsConstants.MusicsSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case musicsConstants.MusicsVideoStatusUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateStatus: false,
			};
		case musicsConstants.MusicsVideoStatusUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload.message,
			};
		case musicsConstants.MusicsVideoStatusUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				isFormSubmit: false,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default musicsData;
